import React, { useEffect } from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import {TextField,Divider,Button, Container, Grid, Typography} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import MenuItem from '@material-ui/core/MenuItem';

import WrapTextIcon from '@material-ui/icons/WrapText';
import OpacityIcon from '@material-ui/icons/Opacity';
import Swal from 'sweetalert2'
import {withRouter} from 'react-router-dom'
import {Tooltip} from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


import AccountCircle from '@material-ui/icons/AccountCircle';
import {logout } from '../../../../providers/Autenticate';





const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
});

function StyledRadio(props) {
  const classes = useStyles();

  
  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ModalProfile = (props) => {
  
  const [open, setOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [cliente, setCliente] = React.useState(props.cliente);
  
 

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogoff = () =>{
    logout();
    setAnchorEl(null);
    handleMobileMenuClose();
    window.location.href ='/'
  }

   

  

  return (
    <div>
      <Tooltip title='Profile'>
      <MenuItem onClick={() => { setOpen(true) }}>Profile</MenuItem>
       
      </Tooltip>
      <Dialog
        hideBackdrop
         disableEscapeKeyDown
        fullWidth
        maxWidth='md'
        onClose={() => setOpen(false)} aria-labelledby="customized-dialog-title" open={open}>
      
        <DialogContent dividers >

          
          <br />

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant='subtitle1'> Razão Social </Typography>
              <Typography variant='subtitle2'>{cliente.razaosocial}</Typography>

            </Grid>
            <Grid item xs={3}>
              <Typography variant='subtitle1'> Cidade</Typography>
              <Typography variant='subtitle2'>{cliente.cidade}</Typography>

            </Grid>
            <Grid item xs={2}>
              <Typography variant='subtitle1'> Estado</Typography>
              <Typography variant='subtitle2'>{cliente.estado}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant='subtitle1'> Endereço IP</Typography>
              <Typography variant='subtitle2'>{cliente.enderecoIP}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant='subtitle1'> E-mail</Typography>
              <Typography variant='subtitle2'>{cliente.email}</Typography>
            </Grid>


          </Grid>
          <br />
          <br />
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant='button'> Altere sua senha</Typography>
            </Grid>
            <br />
            <Grid item xs={12}>
              <TextField

                size={'small'}
                label='Nova Senha'
                variant='outlined'

                InputLabelProps={{ shrink: true }}


              />
            </Grid>
            <Grid item xs={12}>

              <TextField

                size={'small'}
                label='Confirme nova senha'
                variant='outlined'

                InputLabelProps={{ shrink: true }}

              />

            </Grid>
           </Grid>

           <br />
    
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button color='primary' variant='contained' ><SaveIcon /> Gravar Nova Senha</Button>
            <Button color='primary' variant='contained' onClick={() => { handleLogoff() }}  ><ExitToAppIcon /> Fazer Logout</Button>
          </div>


        </DialogContent>
        <DialogActions>
          <Grid item xs={3} spacing={2} className='container-buttons'>
           
            <Button color='secondary' variant='contained' autoFocus onClick={() => setOpen(false)} style={{marginLeft:'40%'}} ><ClearIcon /> Fechar</Button>
          </Grid>

        </DialogActions>
      </Dialog>
    </div>
  );
}


export default withRouter(ModalProfile)